import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import '../common.css';

const RoomCreate = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [rentAmount, setRentAmount] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const { isAuthenticated, companyId, userId, logout, token } = useAuth();

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
      return;
    }
  }, [isAuthenticated, companyId, token, logout]);

  const submitData = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!name || !rentAmount) {
      setErrorMessage('Room Name and Rent Amount are required!');
      setIsLoading(false);
      return;
    }

    const RoomCreateData = {
      CompanyId: companyId,
      Name: name,
      Description: description,
      RentAmount: rentAmount,
      CreatedBy: userId,
      CreatedDate: new Date(),
    };

    postData('RoomApi', RoomCreateData, token)
      .then(() => {
        setSuccessMessage('Room created successfully!');
        setErrorMessage('');
        setTimeout(() => {
          history.push('/RoomIndex');
        }, 1500);
      })
      .catch((error) => {
        console.error('Room Create error:', error);
        setErrorMessage('Failed to create room');
        setIsLoading(false);
      });
  };

  return (
    <Fragment>
      <div className="form-container">
        <div className="form-card">
          {/* Header */}
          <div className="form-header">
            <h1 className="form-title">Create Room</h1>
            <div className="form-actions">
              <Link to="/RoomIndex" className="btn-back">
                <ArrowBackIcon fontSize="small" />
                Back to List
              </Link>
              <button className="btn-save" onClick={submitData} disabled={isLoading}>
                {isLoading ? (
                  <CircularProgress size={18} color="inherit" />
                ) : (
                  <>
                    <SaveIcon fontSize="small" />
                    Save
                  </>
                )}
              </button>
            </div>
          </div>

          {/* Messages */}
          {errorMessage && <div className="message error" style={{ margin: '16px 20px 0' }}>{errorMessage}</div>}
          {successMessage && <div className="message success" style={{ margin: '16px 20px 0' }}>{successMessage}</div>}

          {/* Form Body */}
          <div className="form-body">
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Room Name / No. *</label>
                <input
                  className="form-input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  placeholder="Enter room name or number"
                />
              </div>
              <div className="form-group" style={{ flex: 2 }}>
                <label className="form-label">Description</label>
                <input
                  className="form-input"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  type="text"
                  placeholder="Enter description"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Rent Amount *</label>
                <input
                  className="form-input"
                  value={rentAmount}
                  onChange={(e) => setRentAmount(e.target.value)}
                  type="number"
                  placeholder="Enter rent amount"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default RoomCreate;
